/* eslint-disable */
import useHostGlobals from 'appHost/Globals'
import { useUser } from '~hooks'
import { UseGlobalsData } from './interfaces'

const useGlobals = (): UseGlobalsData => {
  const hostGlobals = useHostGlobals()

  const globals = {
    user: hostGlobals?.user || useUser(),
    history: hostGlobals?.history,
    amplitude: hostGlobals?.amplitude,
  }

  return globals
}

export default useGlobals
